// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"186":"d8f7d554","400":"343049e5"}[chunkId] + ".chunk.js";
};